<template>
    <div class="wrap">
        <ul class="tab">
            <li :class="{active:tabIndex===0}" @click="handlerTab(0)">可用优惠券（{{availableCoupon.length}}）</li>
            <li :class="{active:tabIndex===1}" @click="handlerTab(1)">不可用优惠券（{{unavailableCoupon.length}}）</li>
        </ul>
        <div class="list">
            <EmptyData :message="tabIndex===0 ? '暂无可用优惠券':'暂无不可用优惠券'" v-if="tableData.length === 0" />
            <ul class="coupon-list" :class="{noMake:tabIndex==1}" v-else>
                <li :class="{active:chooseItem.id===item.id}" v-for="(item,index) in tableData" :key="item.id">
                    <div class="coupon-item">
                        <dl @click="toggleCoupon(item)">
                            <dt>
                                <p class="amount" v-if="item.type==0"><b>{{item.discount}}</b>元</p>
                                <p class="amount" v-else><b>{{(item.discount * 100)/10}}</b>折</p>
                                <p v-if="item.minPrice">满{{item.minPrice}}元可用</p>
                                <p v-if="item.maxPrice">{{item.maxPrice}}元以内可用</p>
                            </dt>
                            <dd>
                                <p class="amount">{{item.name}}</p>
                                <p class="period" v-if="item.expireType==1">有效期：{{item.startAt | formatDate2}}-{{item.endAt | formatDate2}}</p>
                                <p class="period" v-else>截止日：{{item.endAt | formatDate2}}</p>
                                <p class="btn">
                                    <span v-if="tabIndex==0">
                                        <b><i class="el-icon-check"></i></b>
                                    </span>
                                </p>
                            </dd>
                        </dl>
                        <div class="des" :class="{isOpen: openItems.includes(index)}" @click="toggle(index)">
                            <div class="des-content">
                                <p v-html="item.description"></p>
                                <span class="arrow">
                                    <i class="el-icon-arrow-down"></i>                                
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="footer" v-if="tableData.length !== 0">
            <p>共计减免：<b>{{chooseItem.discountAmount || 0}}元</b></p>
            <span @click="submit">确定选择</span>
        </div>
    </div>
</template>

<script>
import EmptyData from "@com/EmptyData";
export default {
    data () {
        return {
            tabIndex:0,
            availableCoupon:this.couponData.availableCoupon,
            unavailableCoupon:this.couponData.unavailableCoupon,
            tableData:this.couponData.availableCoupon,
            openItems:[],//优惠券列表内容展开的索引
            chooseItem:{},
        }
    },
    props: {
        couponData:{
            type:Object,
            default: () => ({})
        },
        currentCoupon:{
            type:Object,
            default: () => ({})
        }
    },
    components: {EmptyData},
    watch:{
        couponData (val) {
            this.availableCoupon = val.availableCoupon;
            this.unavailableCoupon= val.unavailableCoupon;
            this.tableData = val.availableCoupon;
            this.tabIndex = 0;
        },
        currentCoupon: {
            handler(val) {
                this.chooseItem = val;
            },
            immediate: true,
        }
    },
    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    created() {},
    mounted() {},
    methods: {
        handlerTab(value) {
            this.tabIndex = value;
            this.openItems = [];
            this.tableData = value === 0 ? this.availableCoupon : this.unavailableCoupon;
            if(value==1){
                zhuge.track('用户中心_查看不可用优惠券', {'渠道': this.channelCodeValue})
            }
        },
        toggle(index){
            let itemIndex = this.openItems.indexOf(index);
            if (itemIndex === -1) {
                this.openItems=[index];
            } else {
                this.openItems=[];
            }
        },
        toggleCoupon(item){
            if(this.tabIndex === 0){
                if(this.chooseItem.id === item.id){
                    this.chooseItem = {};
                }else{
                    this.chooseItem = item;
                }
            }
        },
        submit(){
            zhuge.track('用户中心_确定选择优惠券', {'渠道': this.channelCodeValue})
            this.$emit('chooseCurrentCoupon', this.chooseItem);
        }
    },
}

</script>
<style scoped lang='less'>
.wrap{
    width: 100%;
    display: flex;
    flex-direction: column;
    .tab{
        display: flex;
        font-size: 14px;
        color: #A8A8A8;
        padding-bottom: 15px;
        li{
            cursor: pointer;
            margin-right: 30px;
        }
        li.active{
            color:#547EFF;
        }
        
    }
    /deep/.list{
        flex: 1;
        overflow-y: auto;
        padding:15px 10px;
        .coupon-list{
            display: flex;
            justify-content:space-between;
            flex-wrap: wrap;
            li{
                cursor: pointer;
                position: relative;
                width: 360px;
                height: 143px;
                margin-bottom: 20px;
                .coupon-item{
                    position:absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    background-color:#FBFBFB;
                    border-radius: 10px;
                    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
                    dl{
                        background-color: #fff;
                        border-radius: 10px;
                        display: flex;
                        font-size: 10px;
                        height: 117px;
                        overflow: hidden;
                        dt{
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            width: 109px;
                            text-align: center;
                            border-right: 2px dashed #f5f5f5;
                            p{
                                color: #FEB844;
                                font-size: 10px;
                                margin-top: 3px;
                            }
                            .amount{
                                color: #FF3528;
                                font-size: 18px;
                                b{
                                    font-size: 26px;
                                }
                            }
                            &::before{
                                content: "";
                                display: block;
                                position: absolute;
                                top: -6px;
                                right: -7px;
                                background-color: #F7F7F7;
                                height: 12px;
                                width: 12px;
                                border-radius:6px;
                            }
                            &::after{
                                content: "";
                                display: block;
                                position: absolute;
                                bottom: -6px;
                                right: -7px;
                                background-color: #F7F7F7;
                                height: 12px;
                                width: 12px;
                                border-radius:6px;
                            }
                        }
                        dd{
                            flex: 1;
                            width:0;
                            padding: 25px 18px 0 6px;
                            .amount{
                                font-size: 14px;
                                color: #17193E;
                                font-weight: bold;
                                margin-bottom: 6px;
                                width: 100%;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                            }
                            .period{
                                color:#5F5F5F;
                                font-size:14px;
                            }
                            .btn{
                                padding-top: 8px;
                                display: flex;
                                justify-content:flex-end;
                                span{
                                    b{
                                        box-sizing: border-box;
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        border-radius: 50%;
                                        border: 2px solid #547EFF;
                                        display: flex;
                                        justify-content:center;
                                        align-items:center;
                                        i{
                                            display: none;
                                            font-size: 16px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .des{
                        background-color:#FBFBFB;
                        position: relative;
                        z-index: 2;
                        .des-content{
                            padding: 5px 18px;
                            font-size: 12px;
                            color:#A7A5A5;
                            line-height: 18px;
                            display: flex;
                            justify-content: space-between;
                            overflow: hidden;
                            height: 26px;
                            box-sizing: border-box;
                            cursor: pointer;
                            p{
                                padding-right:10px;
                                width: 100%;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                word-break: break-all;
                            }
                            .arrow{
                                padding-top:2px;
                                display:block;
                                font-weight: bold;
                                font-size: 14px;
                                .el-icon-arrow-down{
                                    display: block;
                                    transition: transform 0.2s ease-in-out;
                                }
                            }
                        }
                    }
                    .des.isOpen{
                        z-index: 3;
                        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                        border-radius:0 0 10px 10px;
                        .des-content{
                            overflow: visible;
                            height:auto;
                            p{
                                white-space: normal;
                            }
                            .arrow{
                                .el-icon-arrow-down{
                                    transform:rotate(180deg); 
                                }
                            }
                        }
                    }
                } 
            }
            li.active{
                dl{
                    background-color:#FFEAEF;
                    dd{
                        .btn{
                            span{
                                b{
                                    background-color: #547EFF;
                                    i{
                                        padding-top: 1px;
                                        display: block;
                                        color:#fff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
        }
        &::-webkit-scrollbar-track-piece {
            background-color: rgba(0, 0, 0, 0.2);
            -webkit-border-radius: 6px;
        }
        &::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(125, 125, 125, 0.7);
            -webkit-border-radius: 6px;
        }
        &::-webkit-scrollbar-thumb:horizontal {
            width: 5px;
            background-color: rgba(125, 125, 125, 0.7);
            -webkit-border-radius: 6px;
        }
    }
    
    .footer{
        width: 100%;
        padding: 24px 10px;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        p{
            font-size:16px;
            color:#000;
            b{
                color:#FF0000;
            }
        }
        span{
            cursor: pointer;
            display: block;
            font-size: 16px;
            color:#fff;
            background-color:#547EFF;
            width: 114px;
            height:36px;
            border-radius: 6px;
            line-height: 36px;
            text-align: center;
        }
    }
}
</style>